module.exports = __webpack_public_path__ + "static/media/m_25.a70ffca1.png";